import { render, staticRenderFns } from "./NewClinicModal.vue?vue&type=template&id=4ad2f700&scoped=true&"
import script from "./NewClinicModal.vue?vue&type=script&lang=js&"
export * from "./NewClinicModal.vue?vue&type=script&lang=js&"
import style0 from "./NewClinicModal.vue?vue&type=style&index=0&id=4ad2f700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2f700",
  null
  
)

component.options.__file = "NewClinicModal.vue"
export default component.exports